import { render, staticRenderFns } from "./AddClinicalSkillModal.vue?vue&type=template&id=621d5f6b&scoped=true&"
import script from "./AddClinicalSkillModal.vue?vue&type=script&lang=js&"
export * from "./AddClinicalSkillModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621d5f6b",
  null
  
)

export default component.exports